import { format } from "date-fns";

const fmtDate = (d) => (d ? format(new Date(d), "yyyy-MM-dd") : "—");
const fmtMoney = (n) =>
   n === null || n === undefined || isNaN(n)
      ? "—"
      : new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 }).format(n);

// Composite, never-null row identity — mirrors Reconcile's `rowKeyOf`. Unique per row on
// both sides (statement rows have a unique sd id, ERP rows a unique esh id) and never null,
// so the single-open expand state can never collide across rows.
const rowKey = (r) => `${r.sup_state_detail_external_id ?? "x"}::${r.esh_external_id ?? "x"}`;

const baseBody = ({ from, to, status, sort, invoiceNo, pageIndex, pageSize }) => {
   const fd = new FormData();
   fd.append("_page_index", pageIndex ?? 0);
   fd.append("_page_size", pageSize ?? 10);
   if (from) fd.append("_from", format(from, "yyyy-MM-dd"));
   if (to) fd.append("_to", format(to, "yyyy-MM-dd"));
   fd.append("_status", status ?? "attention");
   fd.append("_sort", sort ?? "attention");
   if (invoiceNo) fd.append("_invoice_no", invoiceNo);
   return fd;
};

const SIDES = {
   statement: {
      key: "statement",
      label: "Supplier Statements",
      endpoint: "/getStatementInvoices.sz",
      rowKey,
      buildBody: baseBody,
      columns: [
         { key: "supplier", label: "Supplier", kind: "text" },
         { key: "invoice_no", label: "Invoice number", kind: "text" },
         { key: "invoice_date", label: "Invoice date", kind: "date" },
         { key: "statement_date", label: "Statement date", kind: "date" },
         { key: "statement_amount", label: "Statement amount", kind: "money" },
         { key: "allocated", label: "Matched", kind: "money" },
         { key: "variance", label: "Variance", kind: "money" },
         { key: "match_status", label: "Status", kind: "status" },
      ],
   },
   erp: {
      key: "erp",
      label: "Protractor (ERP)",
      endpoint: "/getInvoices.sz",
      rowKey,
      buildBody: baseBody,
      columns: [
         { key: "supplier", label: "Supplier", kind: "text" },
         { key: "invoice_no", label: "Invoice number", kind: "text" },
         { key: "invoice_date", label: "Invoice date", kind: "date" },
         { key: "erp_amount", label: "ERP amount", kind: "money" },
         { key: "allocated", label: "Matched", kind: "money" },
         { key: "variance", label: "Variance", kind: "money" },
         { key: "match_status", label: "Status", kind: "status" },
      ],
   },
};

export const renderCell = (kind, value) => {
   if (kind === "date") return fmtDate(value);
   if (kind === "money") return fmtMoney(value);
   return value ?? "—";
};

// Map an Invoices row (statement OR ERP side) to the rowData shape ReconcileLineDetailPanel reads.
// Confidence/_obj fields are intentionally absent — the panel renders without those badges.
export const toReconcilePanelRowData = (row) => ({
   sd_id: row.sup_state_detail_external_id ?? null,
   en_id: row.esh_external_id ?? null,
   sd_parsed_invoice_no: row.invoice_no ?? "",
   sd_invoice_no: row.invoice_no ?? "",
   sd_invoice_date: row.invoice_date ?? null,
   sd_amount: row.statement_amount ?? row.erp_amount ?? null,
   sd_po_no: row.po_no ?? null,
   en_invoice_id: row.invoice_no ?? "",
   esh_parsed_invoice_id: row.invoice_no ?? "",
   en_invoice_amount: row.erp_amount ?? null,
});

export default SIDES;
